var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('newsletter-form',{attrs:{"header":_vm.slice.primary.h3,"teaser":_vm.slice.primary.p,"footer-text":_vm.slice.primary.footer_p,"image":_vm.slice.primary.img}})}
var staticRenderFns = []

export { render, staticRenderFns }